__turbopack_context__.v({
  "accountSnapshotIconsDev": "navheader-module-scss-module__P7lhFG__accountSnapshotIconsDev",
  "accountSnapshotPlaceholderButton": "navheader-module-scss-module__P7lhFG__accountSnapshotPlaceholderButton",
  "active": "navheader-module-scss-module__P7lhFG__active",
  "announcementBannerWrapper": "navheader-module-scss-module__P7lhFG__announcementBannerWrapper",
  "bannerFixed": "navheader-module-scss-module__P7lhFG__bannerFixed",
  "bannerHidden": "navheader-module-scss-module__P7lhFG__bannerHidden",
  "bannerSearchHidden": "navheader-module-scss-module__P7lhFG__bannerSearchHidden",
  "buttonWrapper": "navheader-module-scss-module__P7lhFG__buttonWrapper",
  "darktheme": "navheader-module-scss-module__P7lhFG__darktheme",
  "hamburgerIcon": "navheader-module-scss-module__P7lhFG__hamburgerIcon",
  "headerBackground": "navheader-module-scss-module__P7lhFG__headerBackground",
  "headingLinks": "navheader-module-scss-module__P7lhFG__headingLinks",
  "helpCenter": "navheader-module-scss-module__P7lhFG__helpCenter",
  "iconsWrapper": "navheader-module-scss-module__P7lhFG__iconsWrapper",
  "leftContent": "navheader-module-scss-module__P7lhFG__leftContent",
  "logoSmallWrapper": "navheader-module-scss-module__P7lhFG__logoSmallWrapper",
  "logoWrapper": "navheader-module-scss-module__P7lhFG__logoWrapper",
  "modalBackground": "navheader-module-scss-module__P7lhFG__modalBackground",
  "navAccount": "navheader-module-scss-module__P7lhFG__navAccount",
  "navDropdown": "navheader-module-scss-module__P7lhFG__navDropdown",
  "navDropdownButton": "navheader-module-scss-module__P7lhFG__navDropdownButton",
  "navDropdownOpenStyles": "navheader-module-scss-module__P7lhFG__navDropdownOpenStyles",
  "navFixed": "navheader-module-scss-module__P7lhFG__navFixed",
  "navStrip": "navheader-module-scss-module__P7lhFG__navStrip",
  "noAccountSpacing": "navheader-module-scss-module__P7lhFG__noAccountSpacing",
  "noOverlap": "navheader-module-scss-module__P7lhFG__noOverlap",
  "rightContent": "navheader-module-scss-module__P7lhFG__rightContent",
  "searchContainer": "navheader-module-scss-module__P7lhFG__searchContainer",
  "searchIcon": "navheader-module-scss-module__P7lhFG__searchIcon",
  "searchMobileCloseButton": "navheader-module-scss-module__P7lhFG__searchMobileCloseButton",
  "searchMobileTop": "navheader-module-scss-module__P7lhFG__searchMobileTop",
  "searchMobileTopHeading": "navheader-module-scss-module__P7lhFG__searchMobileTopHeading",
  "searchOpen": "navheader-module-scss-module__P7lhFG__searchOpen",
  "searchOpenStyles": "navheader-module-scss-module__P7lhFG__searchOpenStyles",
  "searchOpenTopWrapper": "navheader-module-scss-module__P7lhFG__searchOpenTopWrapper",
  "showModal": "navheader-module-scss-module__P7lhFG__showModal",
  "showModalSearch": "navheader-module-scss-module__P7lhFG__showModalSearch",
  "supportButton": "navheader-module-scss-module__P7lhFG__supportButton",
  "supportPopover": "navheader-module-scss-module__P7lhFG__supportPopover",
  "topNavButton": "navheader-module-scss-module__P7lhFG__topNavButton",
  "topNavItem": "navheader-module-scss-module__P7lhFG__topNavItem",
  "topNavLink": "navheader-module-scss-module__P7lhFG__topNavLink",
  "topWrapper": "navheader-module-scss-module__P7lhFG__topWrapper",
  "whiteBackground": "navheader-module-scss-module__P7lhFG__whiteBackground",
  "wrapper": "navheader-module-scss-module__P7lhFG__wrapper",
});
